import React, { useEffect, useState } from "react";
import { Form, FormGroup, Label } from "reactstrap";
import Utils from "../../utils";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { updateVehicleCheckList } from "../../services/VehiclePartCheckServices";

const UpdateVehiclePartCheck = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { state } = useLocation();

  const [partCheckData, setPartCheckData] = useState({
    id: "",
    name: "",
    description: "",
    is_default: 0,
  });

  const [btnLoader, setBtnLoader] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setPartCheckData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };

  useEffect(() => {
    if (state) {
      setPartCheckData({
        id: state?.id,
        name: state?.name,
        description: state?.description,
        is_default: state?.is_default,
      });
    }
  }, [state]);

  const handlePartCatalogForm = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let updateData = {
      id: partCheckData?.id,

      name: partCheckData?.name,
      description: partCheckData?.description,
      is_default: partCheckData?.is_default,
    };

    updateVehicleCheckList(updateData)
      .then((response) => {
        toast.success(response.data.message);
        navigate("/check-list-vehicles");

        setPartCheckData({
          id: "",
          name: "",
          description: "",
          is_default: 0,
        });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setBtnLoader(false);
      });
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2 px-2">
            <div className="col-sm-6">
              <h1>{t("update_vehicle_part_check")}</h1>
            </div>
            <div className="col-sm-6"></div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row justify-content-start">
            <div className="col-md-12">
              <div className="card card-primary">
                <Form method={`post`} onSubmit={handlePartCatalogForm}>
                  <div className="card-body">
                    <div className="row justify-content-start">
                      <div className="col-md-12">
                        <div className="row justify-content-start align-items-center mb-2">
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label">Name</Label>
                              <input
                                className="form-control"
                                type="text"
                                name="name"
                                value={partCheckData.name}
                                onChange={handleChange}
                                placeholder="Name"
                              />
                            </FormGroup>
                          </div>

                          <div
                            className="col-md-2"
                          >
                            <FormGroup check>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="is_default"
                                checked={partCheckData.is_default === 1}
                                onChange={handleChange}
                              />
                              <Label className="form-check-label pl-2">
                                Is Default
                              </Label>
                            </FormGroup>
                          </div>
                          <div className="col-md-6">
                            <FormGroup>
                              <Label className="col-form-label">
                                Description
                              </Label>
                              <textarea
                                className="form-control"
                                name="description"
                                value={partCheckData.description}
                                onChange={handleChange}
                                placeholder="Description"
                                rows={3}
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col ms-2">
                        <button
                          type="button"
                          className="back-btn"
                          onClick={() => navigate("/check-list-vehicles")}
                        >
                          <i className="bi bi-arrow-left"> </i> {t("back")}
                        </button>
                      </div>
                      <div className="col">
                        <div className="d-flex justify-content-end nxt-btn">
                          {btnLoader === true ? (
                            <button type="submit" className="btn btn-primary">
                              Loading...
                            </button>
                          ) : (
                            <button type="submit" className="btn btn-primary">
                              {t("submit")} <i className="bi bi-check2"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer"></div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UpdateVehiclePartCheck;
